<!--
 * @创建文件时间: 2019-11-10 11:24:30
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-27 14:35:45
 * @联系Qq:1638245306
 * @文件介绍:
 -->
<template>
  <div id="app">
    <router-view />
    <router-tools></router-tools>
  </div>
</template>

<script>
import util from "@/libs/util";
import store from "./store";
import RouterTools from "./components/TestTools/RouterTools";
export default {
  name: "app",
  components: {
    RouterTools,
  },
  watch: {
    "$i18n.locale": "i18nHandle",
  },
  created() {
    this.i18nHandle(this.$i18n.locale);
  },
  methods: {
    // 国际化
    i18nHandle(val, oldVal) {
      util.cookies.set("lang", val);
      document.querySelector("html").setAttribute("lang", val);
    },
    async getMenu() {
      const db = await this.$store.dispatch("d2admin/db/database");

      let menu = db.get("menu").value();
      if (menu) {
        // this.$store.commit('d2admin/menu/headerSet', menu)
        this.$store.commit("d2admin/menu/asideSet", menu);
        this.$store.commit("d2admin/search/init", menu);
      }
    },
  },
  mounted() {
    this.getMenu();
  },
};
</script>

<style lang="scss">
@import "~@/assets/style/public-class.scss";

.el-table th.gutter {
  display: table-cell !important;
}

.label-blue > label {
  color: #2f74ff;
  line-height: 20px !important;
}
.form-label > label {
  line-height: 20px !important;
}
/**.dialogStyle 弹出选择层的样式 */
.dialogStyle {
  height: 700px;
}
#app {
}
.el-form-item--medium .el-form-item__label {
  line-height: 20px !important;
}
.el-form-item--small .el-form-item__label {
  line-height: 20px !important;
}
.text-align_right {
  text-align: right;
  width: 100%;
}
.el-input__inner {
  border-color: #bfbfbf !important;
}
.el-textarea__inner {
  border-color: #bfbfbf !important;
}
.el-table--border,
.el-table--group {
  border-color: #bfbfbf !important;
}
.el-table td,
.el-table th.is-leaf {
  border-color: #bfbfbf !important;
}
.el-table {
  border-bottom: 1px solid #bfbfbf !important;
}
.el-menu--inline {
  background-color: rgba(0, 0, 0, 0.22) !important;
}
//大图预览的关闭
.el-image-viewer__wrapper .el-icon-circle-close {
  color: #fff !important;
  font-size: 1.5em !important;
}
.el-image-viewer__img {
  max-height: 80% !important;
}
.dialogFormCom .el-dialog .el-dialog__body {
  max-height: 450px !important;
  overflow: auto !important;
}
/***数字右显示 */
.el-input-number--medium .el-input__inner {
  text-align: right !important;
}
.el-input-number .el-input__inner {
  text-align: right !important;
}

/****input */
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #898989 !important;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #898989 !important;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #898989 !important;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #898989 !important;
}
.el-input.is-disabled .el-input__inner {
  color: #676767 !important;
}
/***textarea */
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #898989 !important;
}

textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #898989 !important;
}

textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #898989 !important;
}

textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #898989 !important;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #676767 !important;
}
/****时间框 */
.el-range-editor.is-disabled input {
  color: #676767 !important;
}
/****button框 */
.el-button--info.is-plain.is-disabled,
.el-button--info.is-plain.is-disabled:active,
.el-button--info.is-plain.is-disabled:focus,
.el-button--info.is-plain.is-disabled:hover {
  color: #676767 !important;
}
/**卡片margin_top */
.card_margintop {
  margin-top: 10px;
}
/***报表的表格*/
.el-table--border th,
.el-table__fixed-right-patch {
  border-bottom: 1px solid #ababab !important;
}
.el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: 1px solid #ababab !important;
}
.select_dialog .dialogStyle {
  height: 650px;
  line-height: 20px;
}
.select_dialog .dialogStyle .el-form-item__label {
  line-height: 30px;
}
.el-form-item .el-select__tags {
  //多选下拉框约束高度
  max-height: 90px;
  overflow-y: scroll;
  max-width: 100% !important;
}
/*滚动条样式*/
*::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
  background-color: transparent;
}

*::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

*::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 0;
  background-color: transparent;
}
.el-notification__group {
  position: static;
}
.el-main {
  padding: 0 0 0 10px !important;
}
/**弹窗组件*/
.dialog-top {
  margin-top: 10px;
}
/**整个页面的边框*/
.theme-d2
  .d2-theme-container
  .d2-theme-container-main
  .d2-theme-container-main-body
  .container-component
  .d2-container-full {
  border: none;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
